<template>
  <v-card flat class="mb-5">
    <v-card-text class="px-7">
      <v-row>
        <v-col cols="12" lg="6">
          <div class="body-2 grey--text">Nama Kepala Sekolah / Pelapor</div>
          <div class="body-1 black--text">
            {{ $getDeepObj(laporanAwal, 'ptk.data.nama') || $getDeepObj(pspDiklatSekolah, 'ptk.nama') }}
          </div>
        </v-col>
        <v-col cols="12" lg="6">
          <div class="body-2 grey--text">Satuan Pendidikan / Sekolah</div>
          <div class="body-1 black--text">
            {{ $getDeepObj(laporanAwal, 'sekolah.nama') || $getDeepObj(sekolah, 'nama') }}
          </div>
        </v-col>
        <v-col cols="12" lg="6">
          <div class="body-2 grey--text">Kabupaten / Kota Satuan Pendidikan / Sekolah</div>
          <div class="body-1 black--text">
            {{ $getDeepObj(laporanAwal, 'sekolah.m_kota.keterangan') || $getDeepObj(sekolah, 'm_kota.keterangan') }}
          </div>
        </v-col>
        <v-col cols="12" lg="6">
          <v-row>
            <v-col v-for="(laporan, id) in laporans" :key="id" cols="12" :lg="laporan.grid || 4">
              <div class="body-2 grey--text">{{ laporan.text }}</div>
              <div>
                <v-chip
                  :class="[
                    !isTerlaksana
                      ? 'orange'
                      : $getDeepObj(detail, `${laporan.value}.k_verval_psp`) > 1
                      ? 'green'
                      : 'grey',
                    'white--text',
                  ]"
                >
                  {{
                    !isTerlaksana
                      ? 'Tidak Ada'
                      : $getDeepObj(detail, `${laporan.value}.k_verval_psp`) > 1
                      ? 'Sudah'
                      : 'Belum'
                  }}
                </v-chip>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-divider class="my-4" />
      <v-alert border="left" colored-border color="primary" class="py-0">
        <div class="ml-2">
          <h3 class="py-1">Berikut Detil Laporan Berkala IHT</h3>
          <span class="grey--text text--darken-1">Pilih salah satu untuk melihat detil dari Laporan Berkala IHT</span>
        </div>
        <v-row no-gutters class="mt-2">
          <template v-for="iht in laporans">
            <v-col :key="iht.value" cols="12" md="4" sm="12">
              <v-card
                outlined
                :dark="kLaporan === iht.value"
                :color="kLaporan === iht.value ? 'green' : ''"
                class="ma-1"
                style="border-radius: 5pt"
              >
                <v-list-item @click="onSwitchLaporan(iht.value)">
                  <v-list-item-content>
                    <div>
                      <v-icon left large> {{ iht.icon }} </v-icon>{{ iht.text }}
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
          </template>
        </v-row>
      </v-alert>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'IhtHeader',
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
    meta: {
      type: Object,
      default: () => {},
    },
    gelombang: {
      type: [Number, String],
      default: 1,
    },
  },
  data() {
    return {
      kLaporan: null,
    };
  },
  computed: {
    laporans() {
      if (this.gelombang === 3 && this.sekolah.k_jenjang === 5) {
        return [
          {
            text: 'Laporan Pembukaan',
            value: 6,
            icon: 'mdi-file-document',
            children: false,
          },
          {
            text: 'Laporan Akhir',
            value: 7,
            icon: 'mdi-file-document',
            children: false,
            grid: 4,
          },
          {
            text: 'Laporan Evaluasi',
            value: 8,
            icon: 'mdi-file-document',
            children: false,
            grid: 4,
          },
        ];
      }

      const laporan = {
        1: [
          {
            text: 'Laporan IHT 1',
            value: 1,
            icon: 'mdi-file-document',
            children: false,
          },
          {
            text: 'Laporan IHT 2',
            value: 2,
            icon: 'mdi-file-document',
            children: false,
          },
          {
            text: 'Laporan IHT 3',
            value: 3,
            icon: 'mdi-file-document',
            children: {
              1: { label: 'A. Laporan Umum', desc: 'A. Laporan Umum' },
              2: { label: 'B. Evaluasi Peserta', desc: 'B. Evaluasi Peserta' },
              3: { label: 'C. Evaluasi IHT', desc: 'C. Rekapitulasi Evaluasi Penyelenggaraan IHT dari Peserta' },
              4: { label: 'D. Umpan Balik', desc: 'D. Umpan Balik' },
              5: { label: 'E. Dok Administrasi', desc: 'E. Dok Administrasi' },
            },
          },
        ],
        2: [
          {
            text: 'Laporan Pembukaan IHT',
            value: 4,
            icon: 'mdi-file-document',
            children: false,
          },
          {
            text: 'Laporan Akhir IHT',
            value: 5,
            icon: 'mdi-file-document',
            children: false,
          },
        ],
        3: [
          {
            text: 'Laporan Pembukaan IHT',
            value: 6,
            icon: 'mdi-file-document',
            children: false,
          },
          {
            text: 'Laporan Akhir IHT',
            value: 7,
            icon: 'mdi-file-document',
            children: false,
            grid: 6,
          },
        ],
      };

      return laporan[this.gelombang];
    },

    laporanAwal() {
      const kLaporan = this.laporans[0]['value'];
      return this.detail[kLaporan] || {};
    },

    pspDiklatSekolah() {
      return this.$getDeepObj(this.meta, 'psp_pelaksana') || {};
    },

    sekolah() {
      return this.$getDeepObj(this.meta, 'sekolah') || {};
    },

    isTerlaksana() {
      return (
        this.$isObject(this.detail) &&
        Object.values(this.detail).filter((laporan) => +laporan.is_terlaksana === 1).length
      );
    },
  },
  methods: {
    reset() {
      this.kLaporan = null;
    },
    onSwitchLaporan(kLaporan) {
      this.kLaporan = kLaporan;
      this.$emit('switch', kLaporan);
    },
  },
};
</script>

<style scoped></style>
